export default __webpack_public_path__ + "media/images/svg/round-paw-icon-74172a25077b4936485dbe5144c51e54.svg";